import { stringify } from "query-string";
import { ConnectionNames, } from "../../contracts";
/**
 * Config for channel path and request method type.
 *
 * @namespace
 * @property {object} ConnectionNames - excluding Sportsbook
 * @property {object} ConnectionNames.MessageChannels
 * @property {string} ConnectionNames.MessageChannels.path
 * @property {HTTPRequestMethod} [ConnectionNames.MessageChannels.method="GET"]
 */
export const ChannelsConfig = {
    [ConnectionNames.stadium]: {
        getLeagueData: {
            path: (params) => (({
                channel: `v1/leagues/${params.leagueId}`,
                params
            }))
        },
        getCategoryData: {
            path: (params) => (({
                channel: `v1/leagues/${params.leagueId}/categories/${params.categoryId}`,
                params
            }))
        },
        getSubCategoryData: {
            path: (params) => (({
                channel: `v1/leagues/${params.leagueId}/categories/${params.categoryId}/subcategories/${params.subCategoryId}`,
                params
            }))
        },
        getEventCategories: {
            path: (params) => (({
                channel: `v1/events/${params.eventId}/categories${params.categoryName ? `?categoryName=${params.categoryName}` : ""}`,
                params
            }))
        },
        getEventCategoryData: {
            path: (params) => (({
                channel: `v1/events/${params.eventId}/categories/${params.categoryId}`,
                params
            }))
        },
    },
    [ConnectionNames.clank]: {
        getWidgetZones: {
            path: (params) => (({
                channel: `/api/widgets/markets/v1/zones${params.zoneId ? `?zones=${params.zoneId}` : ""}`,
                params
            }))
        }
    },
    [ConnectionNames.sherpa]: {
        getNavigationEventsData: {
            path: (params) => (({
                channel: `/v2/nav/leagues/${params.leagueId}`,
                params
            }))
        },
    },
    [ConnectionNames.wildcard]: {
        getLiveData: {
            path: (params) => {
                const hasValidParams = Object.values(params).some(value => value !== undefined);
                return {
                    channel: `/v1/live${hasValidParams ? `?${stringify(params, { skipNull: true, sort: false, arrayFormat: "comma" })}` : ""}`,
                    params
                };
            }
        }
    },
};
//# sourceMappingURL=index.js.map